// @ts-nocheck
import { ButtonIcon, ButtonPresentationProps, ButtonProps } from "@insite/mobius/Button";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss, { StyledProp } from "@insite/mobius/utilities/InjectableCss";
import { ButtonType, MobiusButtonType } from "@toolkit/Framework/Types/Button";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { buttonGetHoverProps } from "@toolkit/Themes/common/props/button";
import { css } from "styled-components";
import { buttonStyles } from "@store/Themes/common/mixins";

/* ------------------------------------------------------------------------------------------ */
/* Related Extensions => src/Extensions/Mobius/Button --------------------------------------- */
/* ------------------------------------------------------------------------------------------ */

const getButton = (
    color: string,
    hoverColor: string,
    type: ButtonType,
    cssOverrides?: InjectableCss,
): ButtonPresentationProps => ({
    shape: "rounded",
    buttonType: type as MobiusButtonType,
    typographyProps: {
        weight: 700,
    },
    color,
    css: buttonStyles(type),
    ...buttonGetHoverProps(hoverColor),
    ...cssOverrides,
});
const extraPrimaryDarkStyles = {
    css: css`
        color: ${getColor("primary")};

        ${ButtonIcon} {
            color: ${getColor("primary.dark")};
        }
        &:not(:disabled):hover {
            ${ButtonIcon} {
                color: ${getColor("primary.dark")};
            }

            color: ${getColor("primary.dark")};
        }
    `,
};
const button: Styleguide["button"] = {
    primary: getButton("primary", "primary.dark", "solid"), // Store Custom Code
    // Bunzl custom card changed hover color for secondary
    secondary: getButton("secondary", "primary.dark", "solid"), // Store Custom Code
    primaryDark: getButton("white", "secondary.light", "solid", extraPrimaryDarkStyles),
    tertiary: getButton("primary", "primary.dark", "outline"), // Store Custom Code
};

export default button;
